import { render } from "./FlowBuilderView.vue?vue&type=template&id=196388db&scoped=true"
import script from "./FlowBuilderView.vue?vue&type=script&lang=js"
export * from "./FlowBuilderView.vue?vue&type=script&lang=js"

import "./FlowBuilderView.vue?vue&type=style&index=0&id=196388db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196388db"]])

export default __exports__